import { Injectable, EventEmitter } from '@angular/core';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/map'

//  Services
import { AmssService } from './amss.service';

@Injectable()
export class AbstractService extends AmssService {
    public UpdateContextEvent$: EventEmitter<any>;

    constructor() {
        super();
        this.UpdateContextEvent$ = new EventEmitter<any>();
    }

    public getAbstracts() {
        return super.getHttpService()
            .GET(this.apiUrl + '/abstract/adata/list/' + this.year, true)
            .map(response => response.json());
    }

    public getAbstract(id: number) {
        return super.getHttpService()
            .GET(this.apiUrl + '/abstractInfo/get/' + this.year + '/' + id, true)
            .map(response => response.json());
    }

    public emitContextEvent(type, unit) {
        this.UpdateContextEvent$.emit({ type: type, data: unit });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/abstract.service.ts